import styled from 'styled-components'

export const StyledLink = styled.a`
    cursor: pointer;
    color: ${properties => properties.theme.variables.colorPrimary};
    font-weight: bold;
    font-size: 0.75rem;
    line-height: 1.2em;
    margin-top: 0.62rem;
    svg {
        height: 30px;
        stroke: ${properties => properties.theme.variables.colorPrimary};
    }
`
